<template>
  <el-row type="flex" justify="space-around" :gutter="9" class="container">
    <el-col :span="9">
      <el-container class="card">
        <div @click="action('instorewaitlist')" tag="span" class="card-link">
          Instore Waitlist
        </div>
      </el-container>
    </el-col>
    <el-col :span="9">
      <el-container class="card">
        <div @click="action('dropoff')" tag="span" class="card-link">
          Dropoff
        </div>
      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import '../components/BaseCard.vue';

export default {
  name: 'ActionPage',
  data() {
    return {
      instoreWaitlist: 'Instore Waitlist',
      dropoff: 'dropoff',
      home: 'home',
      existingSwapMessage: 'Existing Swapper',
      existingSwapPath: 'search'
    };
  },
  mounted() {
    // initialize tags
    this.$store.dispatch('tags/fetchTags');
    // reset selectedTags
    this.$store.dispatch('tags/resetSelectedTags');
    // set donateRemaining to false
    this.$store.dispatch('shopper/setDonateRemaining', false);
  },
  methods: {
    action(choice) {
      this.$store.dispatch('shopper/selectAction', choice);
      if (choice === 'dropoff') {
        this.$router.push('/dropoff_decision');
      } else {
        // hide e-signature tag from existing tags
        var tags = this.$store.getters['tags/getTags'];
        tags.forEach(tag => {
          if (tag.key === 'E_SIGNATURE') {
            tag.hidden = true;
          }
        });
        this.$store.dispatch('tags/setTags', tags);

        this.$router.push('/bin_number');
      }
    }
  }
};
</script>

<style scoped>
.container {
  padding: 0 6vw 0 6vw;
  text-transform: capitalize;
}
</style>
